import React, { forwardRef } from 'react';

import { Typography } from '@_shared/ui/Typography';

import * as S from './Text.style';
import { ITextProps } from './Text.types';

const InformationPopupTextContainer = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.TextContainer ref={ref}>{children}</S.TextContainer>
	),
);
InformationPopupTextContainer.displayName = 'InformationPopupTextContainer';

const InformationPopupTitle = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<Typography type="headline-medium" ref={ref} textAlign="center">
			{children}
		</Typography>
	),
);
InformationPopupTitle.displayName = 'InformationPopupTitle';

const InformationPopupSubText = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<Typography type="body-large" ref={ref} textAlign="center">
			{children}
		</Typography>
	),
);
InformationPopupSubText.displayName = 'InformationPopupSubText';

const InformationPopupWarning = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<Typography type="body-medium" color="red-primary" textAlign="center" ref={ref}>
			{children}
		</Typography>
	),
);
InformationPopupWarning.displayName = 'InformationPopupWarning';

const SingleInputFormPopupTextHeader = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.SingleInputFormPopupTextHeader ref={ref}>{children}</S.SingleInputFormPopupTextHeader>
	),
);
SingleInputFormPopupTextHeader.displayName = 'ISingleInputFormPopupTextHeader';

const SingleInputFormPopupTitle = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<Typography type="title-small" ref={ref} textAlign="center" color="font-primary">
			{children}
		</Typography>
	),
);
SingleInputFormPopupTitle.displayName = 'SingleInputFormPopupTitle';

const SingleInputFormPopupErrorMessage = forwardRef(
	({ children }: ITextProps, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => (
		<S.SingleInputFormPopupErrorMessageWrapper>
			<Typography type="label-medium" ref={ref} textAlign="center" color="orange-primary">
				{children}
			</Typography>
		</S.SingleInputFormPopupErrorMessageWrapper>
	),
);
SingleInputFormPopupErrorMessage.displayName = 'SingleInputFormPopupErrorMessage';

export {
	InformationPopupTextContainer,
	InformationPopupTitle,
	InformationPopupSubText,
	InformationPopupWarning,
	SingleInputFormPopupTitle,
	SingleInputFormPopupErrorMessage,
	SingleInputFormPopupTextHeader,
};
